<script setup>
import { computed } from 'vue'

import Retailer from '@/utilities/retailerHelper.js'

import InlineAgricultureLoader from '@/components/loaders/InlineAgricultureLoader.vue'
import InlineFlexLoader from '@/components/loaders/InlineFlexLoader.vue'

defineProps({
  loading: {
    required: false,
    type: Boolean,
    default: false
  },
  message: {
    required: false,
    type: String,
    default: ''
  },
  customStyle: {
    required: false,
    type: Object,
    default: () => ({})
  },
  customSvgStyle: {
    required: false,
    type: Object,
    default: () => ({})
  },
  isMessageShowing: {
    required: false,
    type: Boolean,
    default: true
  }
})

// Retailer.isFlex() reaktif degil; bkz. RetailerLoading.vue
const isFlex = computed(() => Retailer.isFlex())
</script>

<template>
  <transition name="fade">
    <div v-if="loading" class="loading-container" :style="customStyle">
      <inline-flex-loader v-if="isFlex" :custom-svg-style="customSvgStyle" />
      <inline-agriculture-loader v-else :custom-svg-style="customSvgStyle" />
      <p v-if="isMessageShowing === true" class="font-custom-16 mt-3">{{ message }}</p>
    </div>
  </transition>
</template>

<style scoped>
/*
  body.loading'e bilerek dokunulmuyor: inline loader bir konteyneri kapatir,
  sayfayi degil. Global scroll kilidi yalnizca RetailerLoading'in isi.
*/
.loading-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 18px;
  font-family: 'Inter', sans-serif;
  z-index: 999;
  padding-top: 5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
